<div class="container-xxl">
    <div class="fs-14 mb-5 ls-1 fw-700 text-uppercase font-secondary text-center">
        {{ 'PARTNER_SALONS.select-voivodeship' | translate }}
    </div>

    <div class="row gy-3 gx-3">
        @for (voivodeship of voivodeships$ | async; track voivodeship) {
            <div class="col-12 col-md-6">
                <a [routerLink]="['.', voivodeship]" class="btn btn-outline btn-secondary pointer w-100">
                    {{ voivodeship }}
                </a>
            </div>
        }
    </div>
</div>
